import React, { useState,useContext,useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import {AppConfig} from "../../../appConfig";
import { post_sso_info,get_sso_info  } from "../../menu/_redux/menuCrud";
import {smallBox} from '../../../common';


const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    textAlign: 'right',
    backgroundColor: 'white',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2),
  },
  column: {
    margin: theme.spacing(1),
    direction: 'rtl',
  },
  input: {
    width: 350,
    textAlign: 'right',
    border: '1px solid #eee',
    borderRadius: '4px',
    padding: '8px',
    boxSizing: 'border-box',
  },
  button: {
    margin: theme.spacing(2),
  },
}));

const SsoSettings = () => {
  const {apiServer} = useContext(AppConfig);
  const classes = useStyles();
  const [formData, setFormData] = useState({
    clientId: '',
    secretId: '',
    tokenUrl: '',
    userInfoUrl: '',
  });

  useEffect(() => {
    // Fetch SSO info from backend and update form fields
    get_sso_info(apiServer)
      .then(response => {
        if (response && typeof response === 'object') { // Check if response is an object
          const updatedFormData = {};
          Object.values(response.data).forEach(item => {
            updatedFormData[item.field_name] = item.field_value;
          });
          console.log(updatedFormData);
          setFormData(prevState => ({
            ...prevState,
            ...updatedFormData,
          }));
        } else {
          console.error('خطا در دریافت اطلاعات SSO: Response is not an object');
        }
      })
      .catch(error => {
        if(error.responseText == ''){
          smallBox({
            title: 'خطا',
            content: '<i>' + "اطلاعاتی جهت نمایش وجود ندارد" + '</i>',
            color: '#c70606',
            iconSmall: 'fa fa-times fa-2x fadeInRight animated',
            timeout: 4000,
        });
        }
        console.error('خطا در دریافت اطلاعات SSO:', error);
      });
  }, [apiServer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = () => {
    post_sso_info(apiServer, formData).then(response => {
      smallBox({
        title: 'ثبت شد',
        content: '<i>' + "اطلاعات با موفقیت ثبت شد" + '</i>',
        color: '#659265',
        iconSmall: 'fa fa-check fa-2x fadeInRight animated',
        timeout: 4000,
    });
      })
      .catch(error => {
        console.error('خطا در ارسال اطلاعات:', error);
      });
  };

  return (
    <div className={classes.root}>
      <Typography variant="h4" gutterBottom align="right">
        تنظیمات SSO
      </Typography>
      <Divider />
      {/* Part 1 Line 1*/}
      <div className={classes.row}>
        <div className={classes.column}>
          <Typography variant="subtitle1" align="right">
            Client ID:
          </Typography>
          <TextField
            required
            id="clientId"
            name="clientId"
            value={formData.clientId}
            onChange={handleChange}
            InputProps={{
              className: classes.input,
            }}
            inputProps={{
              maxLength: 100,
            }}
          />
        </div>
        <div className={classes.column}>
          <Typography variant="subtitle1" align="right">
            Secret ID:
          </Typography>
          <TextField
            required
            id="secretId"
            name="secretId"
            value={formData.secretId}
            onChange={handleChange}
            InputProps={{
              className: classes.input,
            }}
            inputProps={{
              maxLength: 100,
            }}
          />
        </div>
      </div>
      {/*END Part 1 Line 1*/}

      {/* Part 2 Line 2*/}
      <div className={classes.row}>
      <div className={classes.column}>
          <Typography variant="subtitle1" align="right">
            آدرس Token:
          </Typography>
          <TextField
            required
            id="tokenUrl"
            name="tokenUrl"
            value={formData.tokenUrl}
            onChange={handleChange}
            InputProps={{
              className: classes.input,
            }}
            inputProps={{
              maxLength: 100,
            }}
          />
        </div>
        <div className={classes.column}>
          <Typography variant="subtitle1" align="right">
            آدرس UserInfo:
          </Typography>
          <TextField
            required
            id="userInfoUrl"
            name="userInfoUrl"
            value={formData.userInfoUrl}
            onChange={handleChange}
            InputProps={{
              className: classes.input,
            }}
            inputProps={{
              maxLength: 100,
            }}
          />
        </div>
      </div>
      {/*END Part 2 Line 2*/}

      {/*Part 3 Line 3*/}
      <div className={classes.row}>
      <div className={classes.column}>
          <Typography variant="subtitle1" align="right">
            آدرس Redirect:
          </Typography>
          <TextField
            required
            id="redirectUrl"
            name="redirectUrl"
            value={formData.redirectUrl}
            onChange={handleChange}
            InputProps={{
              className: classes.input,
            }}
            inputProps={{
              maxLength: 160,
            }}
          />
        </div>
        <div className={classes.column}>
          <Typography variant="subtitle1" align="right">
            آدرس خطا:
          </Typography>
          <TextField
            required
            id="errorUrl"
            name="errorUrl"
            value={formData.errorUrl}
            onChange={handleChange}
            InputProps={{
              className: classes.input,
            }}
            inputProps={{
              maxLength: 60,
            }}
          />
        </div>
      </div>
      {/*END Part 3 Line 3*/}

      {/*Part 4 Line 4*/}
      <div className={classes.row}>
        <div className={classes.column}>
          <Typography variant="subtitle1" align="right">
            آدرس ثبت نام:
          </Typography>
          <TextField
            required
            id="webEntryReg"
            name="webEntryReg"
            value={formData.webEntryReg}
            onChange={handleChange}
            InputProps={{
              className: classes.input,
            }}
            inputProps={{
              maxLength: 160,
            }}
          />
        </div>
      </div>
      {/*END Part 5 Line 5*/}
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={handleSubmit}
      >
        ثبت
      </Button>
    </div>
  );
};

export default SsoSettings;
